<template>
  <div id="system-database-add">
    <ipub-model :title="params.id?'Edit Section':'Add New Section'"
                width="1000px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="journal-website-section-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="journalId"
                        label="Journal">
          <ipub-select placeholder="Journal"
                       :options="personalJournalList"
                       disabled
                       optionKey="id"
                       v-model="journalId" />
        </ipub-form-item>
        <ipub-form-item prop="parentId"
                        v-if="hasSection"
                        label="Section Belonged To">
          <ipub-select placeholder="Section Belonged To"
                       :options="tree"
                       optionKey="id"
                       v-model="params.parentId" />
        </ipub-form-item>
        <ipub-form-item prop="name"
                        label="Sub-Section">
          <ipub-input placeholder="Sub-Section"
                      v-model.trim="params.name" />
        </ipub-form-item>
        <ipub-form-item prop="content"
                        label="Description">
          <ipub-textarea placeholder="Description"
                         v-model.trim="params.content" />
        </ipub-form-item>
        <ipub-form-item label="Keywords"
                        prop="keywords">
          <ipub-input placeholder="Keywords can be separated by a semicolon or carriage return"
                      tag
                      v-model="params.keywords" />
        </ipub-form-item>
        <div class="mar-b-30">
          <a>
            <div class="ipub-p3 line-h-40 flex cusor-point">Section Editor</div>
          </a>
          <div>
            <div class="flex mar-b-30">
              <ipub-input v-model.trim="editorEmail"
                          style="width:300px;margin-right:20px"
                          placeholder="Enter Email" />
              <ipub-button type="primary"
                           class="ipub-h3 line-h-40"
                           @click="addEditor"
                           icon="iconAdd"></ipub-button>
            </div>
            <ipub-table :columns="editorColumns"
                        :pagination="false"
                        :showEmpty="false"
                        :dataSource="params.editorList">
              <template v-slot:name="{record}">
                <a class="link-color"
                   v-if="record.userId"
                   @click="showAuthorDetail(record)">{{record.firstName}} {{record.lastName}}</a>
                <font v-else
                      class="font-color">{{record.firstName}} {{record.lastName}}</font>
              </template>
              <template v-slot:code="{text}">
                <!-- {{identityCode}} -->
                <ipub-tooltip class="border-right">
                  <div slot="title"
                       class="omis">{{sectionEditor[text]}}</div>
                  {{sectionEditor[text]}}
                </ipub-tooltip>
              </template>
              <template v-slot:actions="{ record, index }">
                <ipub-tooltip class="border-right">
                  <div slot="title">Edit</div>
                  <ipub-icon type="iconEdit"
                             @click="edit(record, index, 'authorList')" />
                </ipub-tooltip>
                <ipub-tooltip>
                  <div slot="title">Delete</div>
                  <ipub-icon type="iconDelete"
                             @click="del(index, 'authorList')" />
                </ipub-tooltip>
              </template>
            </ipub-table>
          </div>
        </div>
      </ipub-form>
    </ipub-model>

    <addEditor ref="add-editor"
               :isVisable="isVisableEditor"
               :journalId="params.journalId"
               @confirm="confirmEditor"
               @cancel="cancelEditor">
      <!-- @confirm="confirmEditor" -->
    </addEditor>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import section from '../../../../api/section'
import addEditor from './addEditor.dialog.vue'
import special from '@/api/special'
const editorColumns = [
  {
    title: '',
    enTitle: 'Name',
    width: 80,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 80,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Identity',
    width: 80,
    dataIndex: 'identityCode',
    slot: 'code'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 60,
    dataIndex: 'actions',
    slot: 'actions'
  }
]
export default {
  components: {
    addEditor
  },
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    hasSection: {
      type: String,
      default: '',
    },
    tree: {
      type: Array,
      default () {
        return []
      },
    },
  },
  data () {
    return {
      params: {
        editorList: [],
        keywords: [],
      },
      rules: {},
      editorColumns: editorColumns,
      editorEmail: '',
      isVisableEditor: false,
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      sectionEditor: 'getSectionEditor',
      personalJournalList: 'getPersonalJournalList',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          keywords: [],
        }
      } else {
        if (this.hasSection) {
          this.params.parentId = this.hasSection
          this.rules.parentId = [
            {
              required: true,
              message:
                'Section Belonged To' +
                this.LANGUAGE[this.language].noEmpty
            }
          ]
        }
      }
    },
  },
  mounted () {
    this.getRules()
  },
  methods: {
    async getQuery (id) {
      const res = await section.query(id)
      res.keywords = res.keyword ? res.keyword.split(';') : []
      this.params = res
    },
    async confirm () {
      const flag = this.$refs['journal-website-section-add-form'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          journalId: this.journalId,
          keyword: this.params.keywords ? this.params.keywords.join(';') : ''
        })
        if (this.params.id) {
          await section.edit(this.params.id, data)
          this.$message.success({ title: 'Success', content: 'This Section has been published!' })
        } else {
          await section.add(data)
          this.$message.success({ title: 'Success', content: 'This Section has been saved!' })
        }
        this.$emit('confirm', data)
      }
    },
    edit (val, index) {
      this.isVisableEditor = true
      val.index = index
      this.$refs['add-editor'].getQuery(val)
    },
    del (index) {
      this.params.editorList.splice(index, 1)
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        name: [
          {
            required: true,
            message:
              'Title' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        content: [
          {
            required: true,
            message:
              'Description' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    },
    async addEditor () {
      let flag = false
      if (this.editorEmail) {
        const res = await special.geditorSearch(this.editorEmail)
        if (res && res.id) {
          const f = this.params.editorList.some(item => {
            return item.email === res.email
          })
          if (!f) {
            this.isVisableEditor = true
            this.$refs['add-editor'].getQuery(res)
          } else {
            this.$message.error({
              title: 'Error',
              content:
                'The guest editor already exists, please do not add it again！'
            })
          }
        } else {
          this.$message.error({
            title: 'Error',
            content: 'The mailbox was not searched'
          })
          flag = true
        }
        this.editorEmail = ''
      } else {
        flag = true
      }
      if (flag) {
        this.isVisableEditor = true
      }

      // this.isVisableEditor = true


    },
    confirmEditor (val) {
      this.isVisableEditor = false
      if (val.index || val.index === 0) {
        // console.log(this.params.editorList, 'aaa')
      } else {
        val.index = this.params.editorList && this.params.editorList.length ? this.params.editorList.length : 0
      }
      this.$set(this.params.editorList, val.index, val)
    },
    cancelEditor () {
      this.isVisableEditor = false
    },
  }
}
</script>

<style lang="scss" scoped>
#system-database-add {
  .upload-content {
    height: 77px;
    width: 253px;
    background: $content_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
